import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
const NewApInvoices = (params) => {
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />
        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div className="shadowclass my-4">
              <div class="row mx-0">
                <h4 class="event-alert"> New AP Invoice </h4>
                <div class="col-md-6 px-sm-2 px-0">
                  <ul class="ingredient-info edit-shift">
                    <li>
                      <label class="required">Payee Name </label>
                      <div class="d-flex col">
                        <div className="select-div col">
                          <select
                            name="category_id"
                            class="required"
                            id="IngredientCategoryId"
                          >
                            <option value="">Select</option>
                            <option value="2">Poultry</option>
                            <option value="3">Seafood</option>
                          </select>
                        </div>
                        <a
                          class="link span2"
                          href="/finance_settings/add_payee"
                          target="_blank"
                        >
                          {" "}
                          + New Payee{" "}
                        </a>
                      </div>
                    </li>
                    <li>
                      <label class="required">Invoice ID </label>
                      <div class="input-group mb-2">
                        <input type={"text"} />
                      </div>
                    </li>
                  </ul>
                </div>

                <div class="col-md-6 px-sm-2 px-0">
                  <ul class="ingredient-info edit-shift">
                    <li>
                      <label class="">Invoice Date </label>
                      <div class="input-group">
                        <div class="datePicker">
                          <div class="date-input">
                            <input class=" " type="text" />
                          </div>
                        </div>
                      </div>
                    </li>
                    <li>
                      <label class="">Transaction Date </label>
                      <div class="input-group">
                        <div class="datePicker">
                          <div class="date-input">
                            <input class=" " type="text" />
                          </div>
                        </div>
                      </div>
                    </li>
                    <li>
                      <label class="">Memo </label>
                      <div class="input-group mb-2">
                        <input type={"text"} />
                      </div>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="table-responsive">
                <table class="checklist-table remove-space inventory_table">
                  <thead>
                    <tr>
                      <th> Item ID </th>
                      <th> Account Name </th>
                      <th> Item Description </th>
                      <th> Price </th>
                      <th> Quantity </th>
                      <th> Sub Total </th>
                      <th> Tax Type </th>
                      <th> Tax </th>
                      <th> Total </th>
                      <th> Expense/Asset Account </th>
                      <th class="action-td">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="InventoryRow">
                      <td> 1 </td>
                      <td>
                        <div class="select-div">
                          <div class="false">
                            <select class="required">
                              <option value="375">Harry's HQ</option>
                              <option value="377">Boat Quay Pilot</option>
                            </select>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="false required">
                          <textarea class="required small_textarea"></textarea>
                        </div>
                      </td>
                      <td>
                        {" "}
                        <input
                          class="required price currency invitemPrice"
                          type="text"
                          required="required"
                        />{" "}
                      </td>
                      <td>
                        {" "}
                        <input
                          class="required quantity currency_ing invitemQty"
                          type="text"
                          required="required"
                        />{" "}
                      </td>
                      <td>
                        {" "}
                        <span class="sub_total_val"></span>{" "}
                      </td>
                      <td>
                        {" "}
                        <div className="select-div search-select-ms">
                          <select>
                            <option></option>
                          </select>
                        </div>{" "}
                      </td>
                      <td>
                        {" "}
                        <input
                          class="tax_val number currency"
                          type="text"
                          required="required"
                        />{" "}
                      </td>
                      <td className="total_val"> </td>
                      <td>
                        {" "}
                        <div className="select-div search-select-ms">
                          <select>
                            <option></option>
                          </select>
                        </div>{" "}
                      </td>
                      <td>
                        <a
                          href="#_"
                          class="circle_icon red remove_single_item"
                          val="7581"
                        >
                          <i class="iconSprites cancel-icon"> </i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="my-3">
                <button class="btn green-btn-revert add-plus" type="button">
                  <i class="i-icon"> </i> Add Line Item
                </button>
              </div>

              <div class="total-price row mx-0">
                <div class="paymentStatus col-md-6">
                  <table>
                    <tbody>
                      <tr>
                        <td>
                          <b> Sub-Total </b>
                        </td>
                        <td class="align-right">
                          <b>
                            <span id="sub_total">$0.00</span>
                          </b>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <b> Total Tax </b>
                        </td>
                        <td class="align-right">
                          <b>
                            <span id="total_tax">$0.00</span>
                          </b>
                        </td>
                      </tr>
                      <tr class="grn-txt">
                        <td>
                          <b> Total </b>
                        </td>
                        <td class="align-right">
                          <strong>
                            <span id="grand_total">$0.00</span>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="accordion" id="accordionPanelsStayOpenExample">
              <div className="accordion-item">
                <h2
                  className="accordion-header"
                  id="panelsStayOpen-headingNine2"
                >
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseNine2"
                    aria-expanded="true"
                    aria-controls="panelsStayOpen-collapseNine2"
                  >
                    <div className="col d-flex align-items-center justify-content-between">
                      <h4 className="event-alert p-0 mb-0">
                        Additional Options
                      </h4>
                    </div>
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseNine2"
                  className="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-headingNine2"
                >
                  <div className="">
                    <div className="row mx-0">
                      <div className="container px-0">
                        <div className="shadowclass mt-0">
                          <div class="counts">
                            <h4 class="event-alert"> Expense Spread Options</h4>
                          </div>
                          <div className="row mx-0">
                            <div class="col-md-6 px-sm-2 px-0">
                              <ul class="ingredient-info edit-shift">
                                <li>
                                  <label class="required">
                                    Spread Over Period{" "}
                                  </label>
                                  <div class="input-group select-div">
                                    <select
                                      name="category_id"
                                      class="required"
                                      id="IngredientCategoryId"
                                    >
                                      <option value="">Select</option>
                                      <option value="2">Poultry</option>
                                      <option value="3">Seafood</option>
                                    </select>{" "}
                                  </div>
                                </li>
                                <li>
                                  <label class="required">Spread Type </label>
                                  <div class="input-group select-div mb-2">
                                    <select
                                      name="category_id"
                                      class="required"
                                      id="IngredientCategoryId"
                                    >
                                      <option value="">Select</option>
                                      <option value="2">Poultry</option>
                                      <option value="3">Seafood</option>
                                    </select>{" "}
                                  </div>
                                </li>
                                <li>
                                  <label class="required">
                                    Period End Date{" "}
                                  </label>
                                  <div class="input-group">
                                    <div class="datePicker">
                                      <div class="date-input">
                                        <input class=" " type="text" />
                                      </div>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </div>

                            <div class="col-md-6 px-sm-2 px-0">
                              <ul class="ingredient-info edit-shift">
                                <li>
                                  <label class="required">Frequency </label>
                                  <div class="input-group select-div mb-2">
                                    <select
                                      name="category_id"
                                      class="required"
                                      id="IngredientCategoryId"
                                    >
                                      <option value="">Select</option>
                                      <option value="2">Poultry</option>
                                      <option value="3">Seafood</option>
                                    </select>{" "}
                                  </div>
                                </li>
                                <li>
                                  <label class="">
                                    # of{" "}
                                    <span class="payment_expense">
                                      Payments
                                    </span>
                                  </label>
                                  <div class="input-group mb-2">
                                    <input type={"text"} />
                                  </div>
                                </li>
                                <li>
                                  <label class="">Payment Amounts</label>
                                  <div class="input-group mb-2">
                                    <span class="spread_over_payment_amount">
                                      $0.00
                                    </span>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>

                          <div class="counts">
                            <h4 class="event-alert">
                              Expense Reversal Options
                            </h4>
                          </div>
                          <div className="row mx-0">
                            <div class="col-md-6 px-sm-2 px-0">
                              <ul class="ingredient-info edit-shift">
                                <li>
                                  <label class="required">
                                    Schedule Expense Reversal?
                                  </label>
                                  <div class="input-group select-div">
                                    <select
                                      name="category_id"
                                      class="required"
                                      id="IngredientCategoryId"
                                    >
                                      <option value="">Select</option>
                                      <option value="2">Poultry</option>
                                      <option value="3">Seafood</option>
                                    </select>{" "}
                                  </div>
                                </li>
                              </ul>
                            </div>

                            <div class="col-md-6 px-sm-2 px-0">
                              <ul class="ingredient-info edit-shift">
                                <li>
                                  <label class="required">
                                    Reversal Transaction Date{" "}
                                  </label>
                                  <div class="input-group">
                                    <div class="datePicker">
                                      <div class="date-input">
                                        <input class=" " type="text" />
                                      </div>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>

                        <div class="btn-sec-row clearfix mt-3 mt-sm-0">
                          <button class="btn bordered-btn">
                            {" "}
                            Set As Favourite{" "}
                          </button>
                          <button class="btn cancel mx-2" id="cancel">
                            {" "}
                            Cancel{" "}
                          </button>
                          <button class="btn green-btn-revert mx-0" type="submit">
                            {" "}
                            Submit{" "}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default NewApInvoices;
